import { Authenticator } from "@firecms/core";
import { FirebaseUserWrapper } from "@firecms/firebase";

import { Member } from "@/collections/team";

export const authenticator: Authenticator<FirebaseUserWrapper> = async ({
  user,
  authController,
  dataSourceDelegate,
}) => {
  if (!user?.email) return false;
  else {
    return dataSourceDelegate
      .fetchCollection<Member>({
        path: "team",
        filter: { email: ["==", user.email] },
      })
      .then((entities) => {
        if (Boolean(entities) && entities.length > 0) {
          authController.setExtra({
            roles: entities[0].values.roles ?? [],
          });
          return true;
        }
        return false;
      })
      .catch((e) => {
        console.error(e);
        return false;
      });
  }
};
